import { useFetchBatchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { isLoading, isError } from 'reference-resolvers-lite/Status';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import LoadingValue from './LoadingValue';
import { indexBy } from '../utils/indexBy';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const indexById = indexBy(({
  id
}) => id);
export const ExternalOptionValue = ({
  multi,
  placeholder = EMPTY_PROPERTY_VALUE,
  resolver,
  value
}) => {
  const values = multi ? parseMultiEnumValue(value) : value ? [value] : [];
  const {
    references,
    status
  } = useFetchBatchResolver(resolver, values);
  if (isError(status)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: values.join(', ')
    });
  }
  if (isLoading(status)) {
    return /*#__PURE__*/_jsx(LoadingValue, {});
  }
  if (!references) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: placeholder
    });
  }
  const byIdMap = indexById(references);
  const label = values.map(id => {
    const idStr = String(id);
    const reference = Object.prototype.hasOwnProperty.call(byIdMap, idStr) ? byIdMap[idStr] : undefined;

    // If `useFetchBatchResolver` fails to resolve an id, no reference with that id
    // will be present in the result. Fall back to showing the raw id
    if (!reference) {
      return `${id}`;
    }
    if (!reference.label) {
      return `${reference.id}`;
    }
    return reference.label;
  }).filter(_ => _).join(', ');
  return /*#__PURE__*/_jsx("span", {
    children: label || placeholder
  });
};
export default ExternalOptionValue;